export const convertToBase64 = (file: Blob): Promise<string> =>
  new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = () => {
      resolve(fileReader.result as string);
    };
    fileReader.onerror = (error) => {
      console.log("error in image conversion to base64:  ", error);
      reject(error);
    };
  });

export function extractFileName(url: string): string {
  return url.substring(url.lastIndexOf("/") + 1);
}
